<template>
  <div style="display: flex; width: 100%">
    <div style="width: 50%; margin-right: 5px">
      <div class="bd_card_lv">
        <div
          style="width: 60px; height: 100%; border-radius: 50%"
          class="bg-blue_lv"
        >
          <img class="divcol1-img p-1" src="@/assets/images/kubota/o2.gif" />
        </div>
        <div align="center" style="width: 60px">
          <h2 class="divcol1-h2">O<sub>2</sub></h2>
        </div>
        <div class="w_3" align="center">
          <h2 class="pTextSize pTextL1">
            {{ get_data.o2 * 2
            }}<sub class="ml-1 pTextLBlack" style="font-size: 0.8vw">% </sub>
          </h2>
          <h6 class="thFontthai">ออกซิเจน</h6>
        </div>
      </div>
    </div>
    <div style="width: 50%">
      <div class="bd_card_lv">
        <div
          style="width: 60px; height: 100%; border-radius: 50%"  
          class="bg-blue_lv"
        >
          <img class="divcol1-img p-1" src="@/assets/images/kubota/co.gif" />
        </div>
        <div align="center" style="width: 60px">
          <h2 class="divcol1-h2">CO</h2>
        </div>
        <div class="w_3" align="center">
          <h2 class="pTextSize pTextL1">
            {{ get_data.co
            }}<sub class="ml-1 pTextLBlack" style="font-size: 0.8vw">ppm </sub>
          </h2>
          <h6 class="thFontthai">คาร์บอนมอนนอกไซด์</h6>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="divrow mt-3 mb-2">
    <div class="divcol1">
      <img class="divcol1-img" src="@/assets/images/kubota/o2.gif" />
      <h2 class="divcol1-h2">O<sub>2</sub></h2>

      <h2 class="pTextSize pTextL1">
        {{ (get_data.o2)*2
        }}<sub class="ml-1 pTextLBlack" style="font-size: 0.8vw">% </sub>
      </h2>
      <h6 class="thFontthai" style="">ออกซิเจน</h6>
    </div>

    <img class="imgbg" src="@/assets/images/kubota/Group 5378.png" />
  </div> -->
</template>

<script>
export default {
  props: ["get_data"],
  data() {
    return {};
  },
};
</script>

<style scoped>
.thFontthai {
  font-family: "Charm", cursive;
  font-family: "Kodchasan", sans-serif;
  /* margin-left: 4%; */
  font-size: 0.6vw;
}
.divrow {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
}
.imgbg {
  width: 100%;
}
.pTextSize {
  font-size: 2vw;
  font-weight: 800;
  /* margin-left: 25%; */
}
.divcol1 {
  position: absolute;
  display: flex;
  /* border: 5px solid red; */
  align-items: center;
}
.divcol1-img {
  height: 90%;
  width: 90%;
}
.divcol1-h2 {
  font-size: 1.6rem;
  /* margin-left: 5%; */
  font-weight: 800;
}
.bd_card_lv {
  display: flex;
  border-radius: 50px 30px 30px 50px;
  align-items: center;
  height: 60px;
  width: 100%;
  background: rgba(255, 255, 255, 0.5);
}
.w_3 {
  width: calc(100% - 120px);
}
.bg-blue_lv {
  background: #3bccff;
}
.pTextL1 {
  color: #0cbbc4;
}
.pTextL2 {
  color: #2bc40c;
}
.pTextL3 {
  color: #c4b50c;
}
.pTextL4 {
  color: #c47d0c;
}
.pTextL5 {
  color: #c41c0c;
}
.pTextLBlack {
  color: #111111;
}
@media only screen and (max-width: 767px) {
  .pTextSize {
    font-size: 2rem;
    font-weight: 800;
  }
}
</style>